import React from 'react';
import { Box, Header, SpaceBetween } from '@amzn/awsui-components-react';
import { useParams } from 'react-router-dom';

/**
 * Placeholder for the derived allocation sheet detail page. The full 4-step builder lands in
 * a follow-up task; this stub exists so the list-view link resolves and the route is already
 * registered + gated when the real component arrives.
 */
export default function DerivedAllocationSheetView() {
    const { sheetId } = useParams<{ sheetId: string }>();

    return (
        <SpaceBetween direction="vertical" size="l">
            <Header variant="h1">Derived allocation sheet</Header>
            <Box>Sheet id: {sheetId}</Box>
            <Box color="text-status-info">The derived allocation sheet builder is not yet available.</Box>
        </SpaceBetween>
    );
}
